/* @flow */
import _ from 'lodash';
import cx from 'classnames';
import React from 'react';

import AddButton from 'components/AddButton.jsx';
import Group from 'entities/Group';
import GroupCreateModal from 'groups/components/GroupCreateModal.jsx';
import GroupOrgList from 'groups/components/GroupOrgList.jsx';
import JoinGroupModal from 'groups/components/JoinGroupModal.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Modal from 'components/Modal.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Organization from 'entities/Organization';
import Section from 'groups/components/GroupsNav-Section';
import Timestamp from 'components/Timestamp.jsx';
import Tooltip from 'components/Tooltip.jsx';
import { titleForSection } from 'groups/lib/groupDisplay';
import { SectionShape } from 'groups/lib/groupNavigation';
import getRedirectLocationAfterGroupCreation from 'utils/getRedirectLocationAfterGroupCreation';
import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';
import { addStep } from 'reducers/joyrides';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { AdminSignupRideInformation } from 'constants/rides';

import './styles/GroupsNav.scss';

type GroupOrOrgType = Group | Organization;

const GroupsNav = React.createClass({
  propTypes: {
    sections: React.PropTypes.arrayOf(SectionShape).isRequired,
    canAddGroup: React.PropTypes.bool.isRequired,
    isMuted: React.PropTypes.bool,
    mutedUntil: React.PropTypes.instanceOf(Date),
    addStep: React.PropTypes.func.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      showingModal: !!Modal.getCurrent(),
    };
  },

  componentDidMount() {
    Modal.on('show', this.onModalOpened);
    Modal.on('hide', this.onModalClosed);

    this.props.addStep(AdminSignupRideInformation.name, AdminSignupRideInformation.steps['joyride-subscribed-classes-section']);

    const hasDistrict = this.props.sections.find(section => section.items.length > 0 && section.scope === 'district');
    const hasSchool = this.props.sections.find(section => section.items.length > 0 && section.scope === 'school');

    if (hasDistrict) {
      this.props.addStep(AdminSignupRideInformation.name, AdminSignupRideInformation.steps['joyride-check-out-district']);
    } else if (hasSchool) {
      this.props.addStep(AdminSignupRideInformation.name, AdminSignupRideInformation.steps['joyride-check-out-school']);
    }
  },

  // typecheck: ignore statement
  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    // XXX move check for sections up to ClassNavigation once that wins,
    // so we can assume that props are only updated if they've changed
    // props
    if (!_.isEqual(this.props.sections, nextProps.sections)) {
      return true;
    }
    // state
    const stateKeys = ['showingModal'];
    for (const stateKey of stateKeys) {
      if (this.state[stateKey] !== nextState[stateKey]) {
        return true;
      }
    }
    return false;
  },

  componentWillUnmount() {
    Modal.removeListener('show', this.onModalOpened);
    Modal.removeListener('hide', this.onModalClosed);
  },

  onModalClosed() {
    this.setState({ showingModal: !!Modal.getCurrent() });
  },

  onModalOpened() {
    this.setState({ showingModal: true });
  },

  handleGroupCreated(group: Group) {
    this.context.router.push(getRedirectLocationAfterGroupCreation(group));
  },

  handleGroupJoined(group: Group) {
    this.context.router.push(getRedirectLocationAfterGroupJoin(group));
  },

  renderDescribedSection({ key, scope, items }: {key: string, scope: string, items: GroupOrOrgType[]}) {
    if (scope === 'district') {
      return this.renderDistrictsSection(items);
    } else if (scope === 'school') {
      return this.renderSchoolsSection(items);
    } else if (scope === 'district_organization') {
      return this.renderDistrictOrganizationsSection(items);
    } else if (scope === 'class') {
      if (key === 'classes-owned') {
        return this.renderOwnedClassesSection(items);
      } else {
        return this.renderSubscribedClassesSection(items);
      }
    } else if (scope === 'root') {
      return this.renderRootGroupSection(items);
    } else {
      console.error(`Unsupported section scope '${scope}'`);
      return null;
    }
  },

  renderRootGroupSection(items: GroupOrOrgType[]) {
    return (
      <Section key="root">
        <GroupOrgList items={items} />
      </Section>
    );
  },

  renderDistrictsSection(items: GroupOrOrgType[]) {
    return (
      <Section
        className="joyride-check-out-district"
        key="districts"
        title={titleForSection('districts', items.length)}>
        <GroupOrgList items={items} />
      </Section>
    );
  },

  renderDistrictOrganizationsSection(items: GroupOrOrgType[]) {
    return (
      <Section
        key="district_organizations"
        title={titleForSection('districts', items.length)}>
        <GroupOrgList items={items} />
      </Section>
    );
  },

  renderSchoolsSection(items: GroupOrOrgType[]) {
    return (
      <Section
        key="schools"
        className="joyride-check-out-school"
        title={titleForSection('schools', items.length)}>
        <GroupOrgList items={items} />
      </Section>
    );
  },

  // XXX this should be in a separate component but I've already
  // refactored this so much I'll save it for later.
  renderCreateGroupButton() {
    // TODO add a tooltip about why it's disabled
    // `You can only have ${this.state.ownedGroupsLimit} classes` :
    // 'Create a class'

    const { canAddGroup, isMuted, mutedUntil } = this.props;

    const button = (
      <AddButton
        data-test-selector="create_class_nav_link"
        size="normal"
        className="GroupsNav-section-header"
        disabled={!canAddGroup}
        linkId="GroupsNav-add-class">
        Create a class
      </AddButton>
    );

    if (canAddGroup) {
      return (
        <ModalTrigger
          modal={<GroupCreateModal onCreate={this.handleGroupCreated} />}
          checkForUnsavedChanges>
          {button}
        </ModalTrigger>
      );
    } else if (isMuted) {
      const timestamp = <Timestamp date={mutedUntil} format="long" />;

      return (
        <LayerTrigger
          layer={
            <Tooltip>
              Your messaging privileges have been temporarily suspended until {timestamp}.
            </Tooltip>
          }
          placement="bottom">
          {button}
        </LayerTrigger>
      );
    } else {
      return button;
    }
  },

  renderOwnedClassesSection(items: GroupOrOrgType[]) {
    const title = titleForSection('classes-owned', items.length);

    return (
      <Section
        className="joyride-subscribed-classes-section"
        key="classes-owned"
        title={title}>
        {this.renderCreateGroupButton()}
        <GroupOrgList items={items} />
      </Section>
    );
  },


  // XXX this should be in a separate component but I've already
  // refactored this so much I'll save it for later.
  renderJoinGroupButton() {
    const button = (
      <AddButton
        className="GroupsNav-section-header"
        data-test-selector="join_class_nav_link"
        linkId="GroupsNav-join-class">
        Join a class
      </AddButton>
    );

    return (
      <ModalTrigger modal={<JoinGroupModal onJoin={this.handleGroupJoined} />}>
        {button}
      </ModalTrigger>
    );
  },

  renderSubscribedClassesSection(items: GroupOrOrgType[]) {
    const title = titleForSection('classes-subscribed', items.length);

    return (
      <Section
        key="classes-subscribed"
        title={title}>
        {this.renderJoinGroupButton()}
        <GroupOrgList items={items} />
      </Section>
    );
  },

  render() {
    const { className, sections } = this.props;
    return (
      <nav className={cx('GroupsNav', className)}>
        {sections.map(this.renderDescribedSection)}
      </nav>
    );
  },
});

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ addStep }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(GroupsNav);



// WEBPACK FOOTER //
// ./src/groups/components/GroupsNav.jsx